<template>
    <section>
        <Head title="Edit Challenge" />

        <!--        <template #breadcrumbs>-->
        <!--            <breadcrumbs :data="breadcrumbs"></breadcrumbs>-->
        <!--        </template>-->

        <heading>
            <template #heading>Edit Challenge</template>
        </heading>

        <div class="mx-auto max-w-7xl sm:px-8">
            <form @submit.prevent="updatePost">
                <jet-label class="hidden text-2xl font-semibold" for="images" value="Photos" />
                <media-library-attachment
                    :max-items="12"
                    :sortable="false"
                    :validation-errors="form.errors"
                    :validation-rules="{ accept: ['image/png', 'image/jpeg'], maxSizeInKB: 5120 }"
                    class="mb-6"
                    multiple
                    name="images"
                    route-prefix="media-library"
                    @change="onChange"
                    :initial-value="form.images"
                >
                    <template slot="properties" slot-scope="{ object }">
                        <div class="media-library-property"></div>
                    </template>
                </media-library-attachment>
                <alert-error v-if="form.errors.images">{{ form.errors.images }}</alert-error>

                <div class="mx-2 bg-white rounded-lg shadow overflow-hidden sm:mx-0">
                    <div class="p-7">
                        <div class="flex flex-col space-y-6">
                            <div>
                                <textarea
                                    ref="text"
                                    v-model="form.text"
                                    :class="[form.errors.text ? 'ring-red-500 border-red-500 placeholder-red-500' : 'border-transparent', 'w-full h-64 border hover:border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-indigo-400 rounded-md resize-y']"
                                    placeholder="Write the challenge details..."
                                ></textarea>
                                <alert-error v-if="form.errors.text">
                                    {{ form.errors.text }}
                                </alert-error>
                            </div>

                            <!-- Who to challenge? -->
                            <div>
                                <div class="justify-between space-y-2">
                                    <div v-if="form.personal === true" class="group flex items-center">
                                        <div class="flex items-center justify-center w-11">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                            <input disabled id="personal" :value="true" v-model="form.personal" type="radio" class="hidden w-4 h-4 text-indigo-600 border-gray-400 cursor-pointer focus:ring-indigo-500" />
                                        </div>
                                        <label for="personal" class="flex flex-col flex-grow ml-6" :class="{ 'opacity-50': form.personal === false }">
                                            <span class="text-gray-900 text-sm font-medium sm:text-base" :class="{ 'text-indigo-700': form.personal === true }">I'm Challenging Myself</span>
                                            <span class="text-gray-700 text-xs sm:text-sm" :class="{ 'text-indigo-600': form.personal === true }">This challenge will only be completed by me.</span>
                                        </label>
                                    </div>
                                    <div v-if="form.personal == false" class="group flex items-center">
                                        <div class="flex items-center justify-center w-11">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                            <input disabled id="not_personal" :value="false" v-model="form.personal" type="radio" class="hidden w-4 h-4 text-indigo-600 border-gray-400 cursor-pointer focus:ring-indigo-500" />
                                        </div>
                                        <label for="not_personal" class="flex flex-col flex-grow ml-6" :class="{ 'opacity-50': form.personal === true }">
                                            <span class="text-gray-900 text-sm font-medium sm:text-base" :class="{ 'text-indigo-700': form.personal === false }">I'm Challenging Anyone</span>
                                            <span class="text-gray-700 text-xs sm:text-sm" :class="{ 'text-indigo-600': form.personal === false }">This challenge can be completed by anyone, including myself.</span>
                                        </label>
                                    </div>
                                </div>
                                <alert-error v-if="form.errors.personal">
                                    {{ form.errors.personal }}
                                </alert-error>
                            </div>

                            <!-- Post Anonymously -->
                            <div class="flex flex-row-reverse items-center justify-between mt-6">
                                <span class="flex flex-col flex-grow ml-6" id="anonymous-label">
                                    <span class="text-gray-900 font-medium">Post Anonymously</span>
                                    <span class="text-gray-700 text-sm">Posting anonymously will hide your photo and username from the challenge.</span>
                                </span>
                                <button
                                    @click="form.anonymous = !form.anonymous"
                                    type="button"
                                    :class="{ 'bg-gray-200': !form.anonymous, 'bg-indigo-600': form.anonymous }"
                                    class="relative inline-flex flex-shrink-0 w-11 h-6 border-2 border-transparent rounded-full focus:outline-none cursor-pointer transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    aria-pressed="false"
                                    aria-labelledby="anonymous-label"
                                >
                                    <span class="sr-only">Post Anonymously</span>
                                    <span aria-hidden="true" :class="{ 'translate-x-0': !form.anonymous, 'translate-x-5': form.anonymous }" class="inline-block w-5 h-5 bg-white rounded-full shadow pointer-events-none transform translate-x-0 transition duration-200 ease-in-out ring-0"></span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Button -->
                    <div class="flex items-center justify-end px-4 py-3 text-right bg-gray-50 sm:px-6">
                        <jet-action-message :show="form.recentlySuccessful" class="mr-3"> Saved. </jet-action-message>

                        <jet-action-message :show="form.processing" class="mr-3"> Updating... </jet-action-message>

                        <jet-button :processing="form.processing"> Save Challenge </jet-button>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import JetButton from "@/Jetstream/Button"
import JetFormSection from "@/Jetstream/FormSection"
import JetSectionBorder from "@/Jetstream/SectionBorder"
import JetLabel from "@/Jetstream/Label"
import JetInputError from "@/Jetstream/InputError"
import JetActionMessage from "@/Jetstream/ActionMessage"
import MediaLibraryAttachment from "@/Media-Library/MediaLibraryAttachment"
import JetDialogModal from "@/Jetstream/DialogModal"
import Breadcrumbs from "@/Components/Breadcrumbs"
import Heading from "@/Components/Heading"
import AlertError from "@/Components/Alerts/Error"

export default {
    name: "EditPost",

    layout: AppLayout,

    components: {
        Heading,
        Breadcrumbs,
        JetDialogModal,
        AppLayout,
        MediaLibraryAttachment,
        JetButton,
        JetSectionBorder,
        JetFormSection,
        JetLabel,
        JetInputError,
        JetActionMessage,
        AlertError,
    },

    props: ["post"],

    computed: {
        breadcrumbs() {
            return [
                {
                    text: "Challenges",
                    url: this.route("user.posts.list"),
                },
                {
                    text: this.post.title,
                    url: this.route("posts.show", { user: this.post.tag, post: this.post.id }),
                },
            ]
        },
    },

    watch: {},

    data() {
        return {
            showVideoModal: false,
            form: this.$inertia.form({
                _method: "POST",
                text: this.post.text,
                images: this.post.media,
                anonymous: this.post.anonymous,
                personal: this.post.personal,
            }),
        }
    },

    methods: {
        onChange(media) {
            this.form.images = media
        },

        updatePost() {
            this.form.clearErrors()
            this.form.post(route("posts.update", this.post.id), {
                preserveScroll: true,
            })
        },
    },
}
</script>
